import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function SearchIcon({ className }) {
  return (
    <svg
      className={className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M47.9475 48L38.8086 38.3319C42.4435 34.5667 44.5758 29.6018 44.8036 24.373C45.0313 19.1442 43.3388 14.0127 40.0449 9.94567C36.751 5.87863 32.0834 3.15699 26.9218 2.29372C21.7602 1.43045 16.4611 2.48518 12.0233 5.25911C7.58546 8.03304 4.3155 12.3346 2.8297 17.3529C1.3439 22.3713 1.74489 27.7599 3.9571 32.503C6.16931 37.2462 10.0399 41.0163 14.8394 43.1027C19.6389 45.1891 25.0358 45.4477 30.0127 43.8299"
        stroke="currentColor"
        strokeWidth="3.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchBar({ small, setSearchPhrase }) {
  const { t } = useTranslation();
  const [inputType, setInputType] = useState("");
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();

  function handleKeyDown(event) {
    if (event.key === "Enter" && inputType !== "") {
      navigate(`/search?query=${inputType}`);
    }
  }

  function handleSearchClick() {
    if (inputType !== "") {
      navigate(`/search?query=${inputType}`);
    }
  }

  const showPlaceholder = inputType === "" && !focused;

  return (
    <div className="grid grid-cols-12">
      <div
        className={
          small
            ? "relative col-span-8 col-start-2 my-5"
            : "relative col-span-10 col-start-2"
        }
      >
        <input
          type="text"
          placeholder=""
          className="text-sm md:text-lg text-mainDark text-light h-14 md:h-[76px] pl-4 md:pl-10 rounded-search border-mainDark border-2 outline-none w-full bg-mainWhite shadow-search pr-16 md:pr-[20vw] [&:has(+*:hover)]:border-mainBlue transition-colors duration-300 ease-in-out"
          onChange={(e) => setInputType(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        {/* Custom multi-line placeholder */}
        {showPlaceholder && (
          <span
            className="pointer-events-none absolute left-4 md:left-10 right-16 md:right-[20vw] top-1/2 -translate-y-1/2 text-sm md:text-lg text-mainDark/40 leading-tight"
            aria-hidden="true"
          >
            {t("searchBar.placeholder")}
          </span>
        )}
        <div
          className="h-14 md:h-[76px] mx-auto md:mx-0 bg-primary text-onPrimary hover:bg-mainBlue hover:text-onPrimary dark:bg-cream dark:text-ink dark:hover:bg-mainBlue dark:hover:text-onPrimary px-4 md:px-14 rounded-search w-fit absolute top-0 right-0 transition-colors duration-300 flex flex-row justify-center items-center gap-x-7 cursor-pointer"
          onClick={handleSearchClick}
        >
          <SearchIcon className="max-h-[35px] w-auto shrink-0 md:max-w-max" />
          <span className="text-light hidden text-lg uppercase md:block">
            {t("searchBar.searchLabel")}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
